import { Animate } from "../animate";
import { Icon } from "../Icon/icon";
import { buzzFeatures } from "../../constants";

export const BuzzSection = () => {
  return (
    <section id="buzz" className="py-[56px] lg:py-20">
      <div className="max-width flex flex-col items-center gap-[52px] lg:gap-[56px]">
        <Animate animation="fade-down">
          <div className="max-w-[602px] text-center">
            <h2 className="text-deep-primary text-[32px] font-medium leading-[36px] sm:text-[40px] sm:leading-[40px] lg:text-[64px] lg:leading-[64px]">
              Buzz friends and
              <br />
              Send Money
            </h2>
            <p className="mt-5 text-sm font-medium leading-5 text-grey-800 lg:text-[18px]">
              Connect with friends, chat instantly, and send money seamlessly.
              Buzz makes peer-to-peer payments as easy as sending a message.
            </p>
          </div>
        </Animate>

        <div className="grid w-full grid-cols-1 gap-5 md:grid-cols-3 lg:gap-8 lg:p-7">
          {buzzFeatures.map(({ iconName, title, subtitle }, idx) => (
            <Animate key={iconName} animation="fade-up" delay={idx / 4}>
              <article className="flex min-h-[276px] flex-col rounded-[20px] bg-[#F1F2FA] px-4 py-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg lg:p-6">
                <div className="flex justify-center mt-2 pb-2">
                  <Icon svg={iconName} width={94} height={94} />
                </div>
                <h3 className="mt-5 whitespace-nowrap text-[24px] font-medium leading-[30px] text-deep-primary lg:text-[32px] lg:leading-8">
                  {title}
                </h3>
                <p className="mt-2 text-sm leading-5 font-medium text-grey-800">
                  {subtitle}
                </p>
              </article>
            </Animate>
          ))}
        </div>
      </div>
    </section>
  );
};
